export const comments_3357255 = {"data":{"data":[],"links":{}}}